import { Text } from '@cinch-labs/design-system'
import styles from './flexbox-two-columns.module.css'
import classNames from 'classnames'

export function FlexboxTwoColumns({
  classNamings,
  rows,
}: {
  classNamings?: {
    container: string
    row: string
    column: string
  }
  rows: {
    columns: (string | JSX.Element)[]
    classNames?: string[]
  }[]
}) {
  return (
    <div className={classNames(styles.container, classNamings?.container)}>
      {rows.map((row, i) => (
        <div
          key={'flexbox-row-' + i}
          className={classNames(styles.row, classNamings?.row)}
        >
          {row.columns.map((column, i) => (
            <div
              key={'flexbox-column-' + i}
              className={classNames(styles.column, classNamings?.column)}
            >
              {typeof column === 'string' ? <Text>{column}</Text> : column}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
